import React, { Fragment } from "react";
import styled from "styled-components";
import {
  IconButton,
  ArrowChevronUp,
  ArrowChevronDown,
} from "@conserveit/blocks";

interface Props {
  children?: React.ReactNode;
  visible: boolean;
}

const StyledIconButton = styled(IconButton)`
  float: right;
`;

const Content = styled.div<Props>`
  display: ${({ visible }) => (visible ? `block` : `none`)};
`;

const useVisible = (defaultVisible: boolean) => {
  const [visible, setVisible] = React.useState(defaultVisible);

  return {
    visible,
    toggle: () => setVisible(!visible),
  };
};

export const Expandable: React.FC<Props> = ({
  children,
  visible: defaultVisible = false,
}) => {
  const { visible, toggle } = useVisible(defaultVisible);

  return (
    <Fragment>
      <StyledIconButton
        icon={visible ? <ArrowChevronUp /> : <ArrowChevronDown />}
        onClick={toggle}
      />
      <Content visible={visible}>{children}</Content>
    </Fragment>
  );
};
